import { Button } from '../../components';
import React from 'react';
import { DomesManagementService } from '../../services';
import warning from '../../assets/svg/warning.svg';
import '../Modal/Modal.global.scss';

interface Props {
  handleModalClose: any;
  id: any;
  fetchDomesList: any;
  setShowOverlay: any;
}

const DomesManagementDelete: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose,
    id,
    fetchDomesList,
    setShowOverlay,
  } = props;

  const [deleted, setDeleted] = React.useState(false);
  const [error, setError] = React.useState('');
  const deleteDomesService = () => {
    setShowOverlay(true);
    setError('');
    DomesManagementService.deleteDomes(id).then(() => {
      setDeleted(true);
      setShowOverlay(false);
    }).catch((err: any) => {
      setShowOverlay(false);
      setError((err && err.response && err.response.data && err.response.data.message) || 'The dome could not be deleted. Please try again.');
    });
  };

  return (
    <>
      {!deleted ? (
        <>
          <img src={warning} alt="warning" />
          <h2>
            Delete Dome
          </h2>
          <p>
            Are you sure you want to delete this dome?
          </p>
          {error && <p className="validation_error">{error}</p>}
          <div className="modalButtonWrapper">
            <Button onClick={handleModalClose}>No</Button>
            <Button intent="danger" onClick={deleteDomesService}>Yes</Button>
          </div>
        </>
      ) : (
        <>
          <h3>
            Dome deleted successfully !
          </h3>
          <Button onClick={() => {
            handleModalClose();
            fetchDomesList({
              page: 1,
              rowsPerPage: 10,
            });
          }}
          >
            Ok
          </Button>
        </>
      )}

    </>
  );
};

export default DomesManagementDelete;
